import { TypedUseSelectorHook, shallowEqual, useSelector } from 'react-redux';
import { AppState } from 'app/store';

export const useAppSelector: TypedUseSelectorHook<AppState> = (callback) => useSelector(callback, shallowEqual);
